import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ApiStatus } from "services/common"

interface OverrideStagedPaymentAutoCancellationResponse extends AxiosResponse {
  data: {
    data: string
    apiStatus: ApiStatus
  }
}

export interface OverrideStagedPaymentAutoCancellationRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    bookingNumber: string
    isOverrideStagedPayment: boolean
  }
}

export function overrideStagedPaymentAutoCancellationApi(
  { params, ...config }: OverrideStagedPaymentAutoCancellationRequest,
  axiosInstance: AxiosInstance,
): Promise<OverrideStagedPaymentAutoCancellationResponse> {
  return axiosInstance({
    method: "post",
    params,
    url: "/admin/booking/override-staged-payment",
    ...config,
  }) as Promise<OverrideStagedPaymentAutoCancellationResponse>
}
